import { cn } from '@discover-lib/utils';
import useIsPast from '@discover-data/stores/hooks/useIsPast';
import Badge, { BadgeProps } from '@discover-ui/badge';

export type AvailabilitySlotCountdownMessageProps = {
  cutOffTime: string;
} & Omit<BadgeProps, 'children'>;

export default function AvailabilitySlotCountdownMessage({
  cutOffTime,
  className,
  ...props
}: AvailabilitySlotCountdownMessageProps) {
  const isPast = useIsPast(cutOffTime);

  if (isPast) {
    return null;
  }

  return (
    <>
      <div
        className={cn(
          'h-1 w-2 self-center border-4 border-solid border-transparent border-b-blue-400 '
        )}
      />
      <Badge
        className={cn(
          'min-h-10 w-screen max-w-[calc(100vw-24px)] text-wrap bg-blue-400 px-2 py-1 text-2xs leading-tight sm:min-h-[26px] sm:w-fit sm:text-nowrap sm:px-2 sm:py-1',
          className
        )}
        {...props}>
        Expiring soon!
      </Badge>
    </>
  );
}
